import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

/** Donut + legenda da Agenda — mesmo tema escuro dos gráficos do AdminDashboard.jsx. */
export default function AgendaDonut({ titulo, data }) {
  const total = data.reduce((a, b) => a + b.value, 0);

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-4">
      <h3 className="text-sm font-manrope font-semibold text-gray-900 text-center mb-2">{titulo}</h3>
      {total === 0 ? (
        <p className="text-center text-xs text-gray-500 py-10">Nenhum dado neste período ainda</p>
      ) : (
        <>
          <div className="relative" style={{ height: 160 }}>
            <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 300, height: 160 }}>
              <PieChart>
                <Pie data={data} cx="50%" cy="50%" innerRadius={45} outerRadius={70} paddingAngle={2} dataKey="value" stroke="#FFFFFF" strokeWidth={2} isAnimationActive={false}>
                  {data.map((entry, i) => <Cell key={i} fill={entry.color} />)}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <span className="text-xl font-outfit font-light text-gray-900">{total}</span>
              <span className="text-[10px] text-gray-500 font-manrope">atividades</span>
            </div>
          </div>
          <div className="space-y-1.5 mt-3 pt-3 border-t border-gray-200">
            {data.filter(d => d.value > 0).map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-xs font-manrope">
                <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: item.color }} />
                <span className="text-gray-900 flex-1">{item.name}</span>
                <span className="text-gray-500">{item.value} ({Math.round(item.value / total * 100)}%)</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
